import { render, staticRenderFns } from "./ComponentLookupSelect.vue?vue&type=template&id=067d33b1&scoped=true&"
import script from "./ComponentLookupSelect.vue?vue&type=script&lang=js&"
export * from "./ComponentLookupSelect.vue?vue&type=script&lang=js&"
import style0 from "./ComponentLookupSelect.vue?vue&type=style&index=0&id=067d33b1&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d33b1",
  null
  
)

export default component.exports